export { MotionAnimations, MotionDurations, MotionTimings } from '@fluentui/theme';
